import { isObjectEqual } from '../../../helpers/common'
import { GROUP_ID, RULES_TYPE } from '../../common/constant'

export const getIdsTableSetting = (data) => {
  const idsEvent = []
  const idsScore = []
  const idsFinancial = []
  const idsFollowingList = []

  data.forEach((item) => {
    if (item.groupId === GROUP_ID[RULES_TYPE.EVENT_RULES]) {
      idsEvent.push(item.alertCriteriaId)
    }
    if (item.groupId === GROUP_ID[RULES_TYPE.SCORE_RULES]) {
      idsScore.push(item.alertCriteriaId)
    }
    if (item.groupId === GROUP_ID[RULES_TYPE.FINANCIAL_RULES]) {
      idsFinancial.push(item.alertCriteriaId)
    }
    if (item.groupId === GROUP_ID[RULES_TYPE.FOLLOWING_LIST]) {
      idsFollowingList.push(item.alertCriteriaId)
    }
  })

  return {
    [RULES_TYPE.EVENT_RULES]: idsEvent,
    [RULES_TYPE.SCORE_RULES]: idsScore,
    [RULES_TYPE.FINANCIAL_RULES]: idsFinancial,
    [RULES_TYPE.FOLLOWING_LIST]: idsFollowingList,
  }
}

export const checkWarningCriteria = (data) => {
  return data.every((criteria) => !criteria?.sendNotification)
}

export const isArrayEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false
  }

  for (let i = 0; i < arr1.length; i++) {
    if (!isObjectEqual(arr1[i], arr2[i])) {
      if (
        arr1[i]?.alertProfileSettingId === arr2[i]?.alertProfileSettingId &&
        arr1[i]?.sendNotification === arr2[i]?.sendNotification &&
        arr1[i]?.sendEmail === arr2[i]?.sendEmail
      ) {
        for (let j = 0; j < arr1[i]?.conditions.length; j++) {
          if (
            arr1[i]?.conditions?.[j]?.conditionId ===
              arr2[i]?.conditions?.[j]?.conditionId &&
            arr1[i]?.conditions?.[j]?.conditionValueId ===
              arr2[i]?.conditions?.[j]?.conditionValueId
          ) {
            continue
          } else {
            return false
          }
        }
        continue
      } else {
        return false
      }
    }
  }

  return true
}
